import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useCarPlateApi } from "../../http/carPlates/api";
import { formatDate } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";
import VersionDialog from "../ui/VersionDialog";

type CarPlateHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const CarPlateHistoryDialog: FC<CarPlateHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const carPlatesApi = useCarPlateApi();

  return (
    <HistoryDialog
      title={i18n.t.carPlates.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={carPlatesApi.getAdminCarPlateVersion}
      getHistory={carPlatesApi.getAdminCarPlateHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {dataVersion.current?.car.id != dataVersion.next.car.id && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.cars.singular}
                  value={
                    dataVersion.current?.car.currentPlateNumber || dataVersion.current?.car.vehicleIdentificationNumber
                  }
                  edited={dataVersion.next.car.currentPlateNumber || dataVersion.next.car.vehicleIdentificationNumber}
                />
              </tr>
            )}
            {dataVersion.current?.nr != dataVersion.next.nr && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.number}
                  value={dataVersion.current?.nr}
                  edited={dataVersion.next.nr}
                />
              </tr>
            )}
            {dataVersion.current?.startDate != dataVersion.next.startDate && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.startDate}
                  value={dataVersion.current && formatDate(dataVersion.current?.startDate, i18n.language)}
                  edited={formatDate(dataVersion.next?.startDate, i18n.language)}
                />
              </tr>
            )}
            {(!dataVersion.current || dataVersion?.current?.endDate !== dataVersion.next.endDate) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.endDate}
                  value={dataVersion.current && formatDate(dataVersion.current?.endDate!, i18n.language)}
                  edited={formatDate(dataVersion.next?.endDate!, i18n.language)}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default CarPlateHistoryDialog;
